import { createContext, createSignal, onMount, useContext } from 'solid-js';
import { useServer, useUser } from 'Shared/SiteProvider';


const TaskCountContext = createContext<{
	taskCount: () => number;
	decrementTaskCount: () => void;
	isAdmin: boolean;
}>();

export function TaskCountProvider(P:{children:any})
{
	const isAdmin = useUser().roles.amGlobalAdmin();
	const [taskCount, setTaskCount] = createSignal(0);

	onMount(() => {
		if (!isAdmin)
			useServer().countArtistManagerTasks.query({}).then(count => setTaskCount(count));
	});

	const decrementTaskCount = () => setTaskCount(c => Math.max(0, c - 1));

	return (
		<TaskCountContext.Provider value={{taskCount, decrementTaskCount, isAdmin}}>
			{P.children}
		</TaskCountContext.Provider>
	);
}

export function useTaskCount()
{
	return useContext(TaskCountContext);
}
